import {
	ConstructionSiteSubmissionColumns,
	ConstructionTabProps,
	PAGES,
} from "@dune/types";
import { DataTable } from "@dune/ui";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getConstructionForContractorColumns } from "../constructionForContractor";

const ConstructionTab: React.FC<ConstructionTabProps> = ({
	constructionSites,
}) => {
	const navigate = useNavigate();

	const handleRowClick = (
		constructionSite: ConstructionSiteSubmissionColumns,
	) => {
		const constructionSiteId =
			constructionSite.constructionSiteSubmission?.constructionSite?.id;
		if (constructionSiteId) {
			navigate(PAGES.PROJECTS.show.withParams(constructionSiteId.toString()));
		}
	};

	const columns = getConstructionForContractorColumns();

	return (
		<div>
			<div className="py-4">
				<h2 className="text-text-main-blue font-semibold">CHANTIERS</h2>
			</div>
			<div>
				<DataTable
					columns={columns}
					data={constructionSites}
					variant="default"
					noResultsText="Aucun chantier associé à cet intervenant"
					onRowClick={handleRowClick}
				/>
			</div>
		</div>
	);
};

export default ConstructionTab;
